// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2aIEg","choiceBoxes":"toolbarselects_choiceBoxes__15thA","simpleField":"toolbarselects_simpleField__3gDpN"};